import ReceiveQuestions from './ReceiveQuestions'
import ReceiveQuestion from './ReceiveQuestion'

export default [{
  path: '/receiveQuestions',
  name: 'ReceiveQuestions',
  component: ReceiveQuestions,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Receive Questions'
  }
}, {
  path: '/receiveQuestion/:question_id',
  name: 'ReceiveQuestion',
  component: ReceiveQuestion,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Receive Question'
  }
}
]



// WEBPACK FOOTER //
// ./src/pages/receiveQuestion/router.js